import React, { useEffect, useState } from "react";
import "../styles/CustomPagination.css";
import { paginationLimits } from "../components/common-data/DropdowData";
import SelectDropdownLabel from "../components/components-react/SelectDropdownLabel";

const CustomPagination = ({
  pagination,
  isPage,
  onChangePage,
  pageLimit,
  setPageLimit,
  isSidebar,
}) => {
  const [paginationLimitInp, setPaginationLimitInp] = useState(() => {
    const found = paginationLimits.find(
      (item) => item.value === pageLimit?.toString()
    );
    if (found) return found;

    const defaultOption =
      paginationLimits.find((item) => item.value === "10") ||
      paginationLimits[1];
    return defaultOption;
  });

  const onChangeDropdown = (value) => {
    setPaginationLimitInp(value);
  };

  const handleBackButtonClick = () => {
    try {
      onChangePage(isPage - 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNextButtonClick = () => {
    try {
      if (onChangePage) {
        onChangePage(isPage + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPagination = () => {
    try {
      return pagination?.[0] || null;
    } catch (error) {
      console.log(error);
    }
  };

  const data = getPagination();

  useEffect(() => {
    if (
      pageLimit &&
      paginationLimitInp?.value &&
      paginationLimitInp?.value !== pageLimit?.toString()
    ) {
      setPageLimit(parseInt(paginationLimitInp?.value));
    }
  }, [paginationLimitInp]); // Removed pageLimit from dependencies to prevent infinite loop

  return (
    <div
      className={`custom-pagination-root ${
        isSidebar ? "sidebar-pagination" : ""
      }`}
    >
      {isSidebar ? (
        <span className="page-info">
          <span className="page-info-value"> {isPage + 1}</span> of{" "}
          {data?.pages}, Total: {data?.pagination}
        </span>
      ) : (
        <span className="page-info">
          Showing Page
          <span> {isPage + 1}</span> of {data?.pages}, Total: {data?.pagination}
        </span>
      )}

      <div className="arrow-and-pagination">
        <div
          className={`pagination-button ${isPage === 0 && "disabled-button"}`}
          onClick={isPage !== 0 ? handleBackButtonClick : null}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-caret-left-fill"
            viewBox="0 0 16 16"
          >
            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
          </svg>
        </div>

        {pageLimit && (
          <div
            className={`commonWrapper pagination-custom-dropdown ${
              paginationLimitInp?.value ? "value-added" : ""
            }`}
          >
            <SelectDropdownLabel
              options={paginationLimits}
              selectedOption={paginationLimitInp}
              setSelectedOption={(selectedValue) =>
                onChangeDropdown(selectedValue)
              }
              name="Limit"
              preventKeyboardOpen={true}
              isShowTop={true}
            />
          </div>
        )}

        <div
          className={`pagination-button ${
            isPage >= data?.pages - 1 && "disabled-button"
          }`}
          onClick={isPage < data?.pages - 1 ? handleNextButtonClick : null}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-caret-right-fill"
            viewBox="0 0 16 16"
          >
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CustomPagination);
